<script setup lang="ts">
import { onMounted, ref } from 'vue';

defineProps<{
  slot: string; // Ad slot ID
  format?: 'auto' | 'rectangle' | 'horizontal' | 'vertical';
  responsive?: boolean;
}>();

const adLoaded = ref(false);
const adContainer = ref<HTMLElement | null>(null);

onMounted(() => {
  // Initialize Google AdSense
  try {
    if (typeof window !== 'undefined' && (window as any).adsbygoogle) {
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
      adLoaded.value = true;
    }
  } catch (e) {
    console.log('AdSense not loaded');
  }
});
</script>

<template>
  <div 
    ref="adContainer"
    class="ad-container flex items-center justify-center min-h-[100px] bg-console-panel/30 border border-console-border/30 rounded-lg overflow-hidden"
    :class="{
      'h-[250px] md:h-[280px]': format === 'rectangle',
      'h-[90px] md:h-[100px]': format === 'horizontal',
      'w-[160px] min-h-[600px]': format === 'vertical'
    }"
  >
    <!-- Google AdSense Ad Unit -->
    <ins 
      class="adsbygoogle"
      style="display:block"
      :data-ad-client="'ca-pub-XXXXXXXXXXXXXXXX'"
      :data-ad-slot="slot"
      :data-ad-format="format || 'auto'"
      :data-full-width-responsive="responsive !== false ? 'true' : 'false'"
    ></ins>
    
    <!-- Fallback/Placeholder when no ad -->
    <div v-if="!adLoaded" class="text-center text-slate-600 text-xs p-4">
      <span class="material-symbols-outlined text-2xl mb-2 block">ads_click</span>
      <span>Advertisement</span>
    </div>
  </div>
</template>

<style scoped>
.ad-container {
  /* Ensure ad is visible */
  min-width: 300px;
}

@media (max-width: 640px) {
  .ad-container {
    min-width: 100%;
  }
}
</style>
